import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useSenderIdProvider} from '../../context/SenderIdProvider'
import {Button} from 'react-bootstrap'

const BulkUploadFeedback = () => {
  const {uploadResponse, setUploadResponse, createBulkSenderIds} = useSenderIdProvider()

  const onCLose = () => setUploadResponse(null)

  return (
    <div className='modal fade' tabIndex={-10} id='kt_modal_10'>
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content py-2'>
          <div className='modal-header border-0'>
            <h4 className='modal-title fs-1'>Bulk Uploaded Feedback</h4>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onCLose}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body px-10 pt-0'>
            {!uploadResponse ? (
              <div className='d-flex justify-content-center'>
                <div className='spinner-border' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <div className='modal-body d-flex justify-content-around'>
                  <div className='bg-success w-25 h-25 text-center text-light fs-4 fw-bold p-4 rounded'>
                    <p>Success</p>
                    {uploadResponse.valid}
                  </div>
                  <div className='bg-danger w-25 h-25 text-center text-light fs-4 fw-bold p-4 rounded'>
                    <p>Invalid</p>
                    {uploadResponse.invalid}
                  </div>
                  <div className='bg-warning w-25 h-25 text-center text-light fs-4 fw-bold p-4 rounded'>
                    <p>Duplicates</p>
                    {uploadResponse.duplicate}
                  </div>
                </div>

                <div className='text-center mt-8'>
                  {/* <Button variant='secondary' data-bs-dismiss='modal' aria-label='Close'>
                    Cancel
                  </Button> */}
                  <Button
                    variant='info'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    // onClick={() => createBulkSenderIds('1')}
                  >
                    Close
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BulkUploadFeedback
